import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown, DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { TestIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';

// @ts-expect-error: ABTestManagerModal is not yet typed
import ABTestManagerModal from 'page-editor-ui/containers/ABTestManagerModal';
import { TestVariationTourSecondStep, useTestVariationApprovalTour
// @ts-expect-error: tour components are not yet typed
} from './TestVariationTours';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AbDropdownControls = ({
  abActiveVariantId,
  abMasterId,
  hasPermissionsToCreateOrEditABTest,
  isVariant,
  masterName,
  onClick,
  variantName
}) => {
  const [manageTestModalOpen, setManageTestModalOpen] = useState(false);
  const pageName = isVariant ? variantName : masterName;
  const onManageTestClick = () => setManageTestModalOpen(true);
  const onManageTestModalClose = () => setManageTestModalOpen(false);
  const {
    goToStepTwo,
    endTour
  } = useTestVariationApprovalTour();
  const dropdown = /*#__PURE__*/_jsx(Dropdown, {
    buttonStyles: {
      paddingInlineStart: '200'
    },
    marginBlockStart: "100",
    onOpenComplete: goToStepTwo,
    onOpenChange: ({
      target: {
        value: open
      }
    }) => {
      if (!open) {
        endTour();
      }
    },
    buttonUse: "form",
    buttonText: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: TestIcon,
        paddingBlock: "0",
        paddingInlineEnd: "100",
        paddingInlineStart: "0"
      }), /*#__PURE__*/_jsx(TruncateString, {
        maxWidth: 250,
        children: pageName
      })]
    }),
    children: /*#__PURE__*/_jsx(TestVariationTourSecondStep, {
      children: /*#__PURE__*/_jsxs(List, {
        wrapChildren: true,
        children: [/*#__PURE__*/_jsx(Button, {
          active: !isVariant,
          onClick: () => onClick(abMasterId),
          "data-variation": "A",
          "data-variation-id": abMasterId,
          children: masterName
        }), /*#__PURE__*/_jsx(Button, {
          active: isVariant,
          onClick: () => onClick(abActiveVariantId),
          "data-variation": "B",
          "data-variation-id": abActiveVariantId,
          children: /*#__PURE__*/_jsx(Text, {
            textAlign: "start",
            children: variantName
          })
        }), hasPermissionsToCreateOrEditABTest && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(DropdownDivider, {}), /*#__PURE__*/_jsx(Button, {
            use: "transparent",
            onClick: onManageTestClick,
            paddingInline: "500",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "abDropdownControls.manageTest"
            })
          })]
        })]
      })
    })
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "abDropdownControls.tooltip"
      }),
      placement: "bottom",
      children: dropdown
    }), manageTestModalOpen && /*#__PURE__*/_jsx(ABTestManagerModal, {
      onClose: onManageTestModalClose
    })]
  });
};
AbDropdownControls.propTypes = {
  abActiveVariantId: PropTypes.number.isRequired,
  abMasterId: PropTypes.number.isRequired,
  hasPermissionsToCreateOrEditABTest: PropTypes.bool.isRequired,
  isVariant: PropTypes.bool.isRequired,
  masterName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variantName: PropTypes.string.isRequired,
  renderPopover: PropTypes.func
};
export default AbDropdownControls;